import React from "react";

interface ChevronDownProps {
  color?: string;
  size?: number;
  className?:string
}

const ChevronDown: React.FC<ChevronDownProps> = ({
  color = "currentColor",
  size = 24,
  className,
}) => {
  return (
    <svg
    className={className}
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke={color}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 9l-7 7-7-7"
      />
    </svg>
  );
};

export default ChevronDown;
